import React, { memo } from 'react';
import DemoEdgeStatusBadge from '../DemoEdgeStatusBadge/DemoEdgeStatusBadge';

export const ExecutionStatusCell = memo(({ status = '', onStepsClick = null }) => {
  if (!status) return null;

  const getStatusClassName = (status) => {
    const statusMap = {
      Succeeded: 'status-succeeded',
      Failed: 'status-failed',
      Canceled: 'status-canceled',
      Rejected: 'status-rejected',
      Queued: 'status-queued',
      'In progress': 'status-in-progress',
      Removed: 'status-removed',
      'Timed out': 'status-timed-out',
    };
    return statusMap[status] || 'status-unknown';
  };

  const handleClick = (e) => {
    e.stopPropagation();
    if (onStepsClick) {
      onStepsClick();
    }
  };

  return (
    <DemoEdgeStatusBadge status={status} statusClassName={getStatusClassName(status)} onClick={handleClick} ariaLabel="View task steps" />
  );
});
